// The dashboard first fetches 10 leads, renders them, then refetches all of them (RCDashboard.jsx).
export const selectLeadsFetchState = ({ rcDashboardReducer: { isLoading, loadingFailed, partialResults } }) =>
  isLoading ? 'loading' : loadingFailed ? 'failed' : partialResults ? 'partial' : 'complete'
